// Telugu
const dict = {
  // Brand / common
  "Every Win, Securely Paid.": "ప్రతి గెలుపుకు, సురక్షిత చెల్లింపు.",
  "Loading Sara777": "Sara777 లోడ్ అవుతోంది",
  "App version {version}": "యాప్ వెర్షన్ {version}",
  "Language": "భాష",
  "Home": "హోమ్",
  "Account": "ఖాతా",
  "Wallet": "వాలెట్",
  "History": "చరిత్ర",
  "All Bids": "అన్ని బిడ్‌లు",
  "Profile": "ప్రొఫైల్",
  "My Profile": "నా ప్రొఫైల్",
  "Open menu": "మెనూ తెరవండి",
  "Close menu": "మెనూ మూసివేయండి",
  "Go back": "వెనక్కి వెళ్ళండి",
  "Back": "వెనక్కి",
  "Close": "క్లోజ్",
  "Open": "ఓపెన్",
  "Submit": "సమర్పించండి",
  "Cancel": "రద్దు చేయండి",
  "Continue": "కొనసాగించండి",
  "Update": "అప్‌డేట్ చేయండి",
  "Copy": "కాపీ చేయండి",
  "Change": "మార్చండి",
  "Refresh": "రిఫ్రెష్ చేయండి",
  "Date": "తేదీ",
  "Status": "స్థితి",
  "Action": "చర్య",
  "Remark": "వ్యాఖ్య",
  "Amount": "మొత్తం",
  "Points": "పాయింట్లు",
  "Bids": "బిడ్‌లు",
  "Session": "సెషన్",
  "Pending": "పెండింగ్‌లో ఉంది",
  "Failed": "విఫలమైంది",
  "Success": "విజయవంతం",
  "optional": "ఐచ్ఛికం",
  "Since {date}": "{date} నుండి",

  // Sidebar
  "Account Statement": "ఖాతా స్టేట్‌మెంట్",
  "Game Rates": "గేమ్ రేట్లు",
  "Terms & Conditions": "నిబంధనలు & షరతులు",
  "Video": "వీడియో",
  "Logout": "లాగ్ అవుట్",
  "Privacy Policy": "గోప్యతా విధానం",

  // Login / sign-up / MPIN / OTP
  "Login": "లాగిన్",
  "Sign up": "సైన్ అప్ చేయండి",
  "New here?": "కొత్తవారా?",
  "Already have an account?": "ఇప్పటికే ఖాతా ఉందా?",
  "Have an account?": "ఖాతా ఉందా?",
  "Enter Number": "నంబర్ నమోదు చేయండి",
  "Enter your valid mobile number": "మీ సరైన మొబైల్ నంబర్ నమోదు చేయండి",
  "Mobile number": "మొబైల్ నంబర్",
  "Mobile Number": "మొబైల్ నంబర్",
  "Enter mobile number": "మొబైల్ నంబర్ నమోదు చేయండి",
  "4-digit MPIN": "4 అంకెల MPIN",
  "Enter your 4-digit MPIN": "మీ 4 అంకెల MPIN నమోదు చేయండి",
  "Show MPIN": "MPIN చూపించు",
  "Hide MPIN": "MPIN దాచు",
  "Create Account": "ఖాతా సృష్టించండి",
  "Create your new account": "మీ కొత్త ఖాతాను సృష్టించండి",
  "Full name": "పూర్తి పేరు",
  "Email address (optional)": "ఇమెయిల్ చిరునామా (ఐచ్ఛికం)",
  "Create MPIN": "MPIN సృష్టించండి",
  "Set a 4-digit PIN to log in quickly": "త్వరగా లాగిన్ అవ్వడానికి 4 అంకెల PIN సెట్ చేయండి",
  "Enter MPIN": "MPIN నమోదు చేయండి",
  "Confirm MPIN": "MPIN నిర్ధారించండి",
  "{label} digit {n}": "{label} అంకె {n}",
  "Never share your MPIN with anyone.": "మీ MPIN ను ఎవరితోనూ పంచుకోవద్దు.",
  "MPINs match": "MPIN లు సరిపోలాయి",
  "MPINs don't match. Try again.": "MPIN లు సరిపోలలేదు. మళ్ళీ ప్రయత్నించండి.",
  "Enter your MPIN to login": "లాగిన్ కోసం మీ MPIN నమోదు చేయండి",
  "Enter OTP": "OTP నమోదు చేయండి",
  "Verify your mobile number": "మీ మొబైల్ నంబర్‌ను ధృవీకరించండి",
  "Verify": "ధృవీకరించండి",

  // Home
  "Add Money": "డబ్బు జోడించండి",
  "Withdraw": "విత్‌డ్రా",
  "Betting is Running Now": "బెట్టింగ్ ఇప్పుడు జరుగుతోంది",
  "Betting is Closed for Today": "ఈరోజుకు బెట్టింగ్ మూసివేయబడింది",
  "Play {name}": "{name} ఆడండి",
  "{name} chart": "{name} చార్ట్",
  "Chart Info": "చార్ట్ సమాచారం",
  "Contact Support": "సపోర్ట్‌ను సంప్రదించండి",
  "Jodi Chart": "జోడి చార్ట్",
  "Pana Chart": "పానా చార్ట్",
  "Past jodi results": "గత జోడి ఫలితాలు",
  "Past panna results": "గత పానా ఫలితాలు",
  "Call Now": "ఇప్పుడే కాల్ చేయండి",
  "Talk to our support team": "మా సపోర్ట్ టీమ్‌తో మాట్లాడండి",
  "WhatsApp": "వాట్సాప్",
  "Chat with us on WhatsApp": "వాట్సాప్‌లో మాతో చాట్ చేయండి",

  // Game types
  "Select a game type to play": "ఆడటానికి గేమ్ రకాన్ని ఎంచుకోండి",
  "Single Digit": "సింగిల్ డిజిట్",
  "Single Digit Bulk": "సింగిల్ డిజిట్ బల్క్",
  "Jodi Digit": "జోడి డిజిట్",
  "Jodi Digit Bulk": "జోడి డిజిట్ బల్క్",
  "Single Pana": "సింగిల్ పానా",
  "Single Pana Bulk": "సింగిల్ పానా బల్క్",
  "Double Pana": "డబుల్ పానా",
  "Double Pana Bulk": "డబుల్ పానా బల్క్",
  "Triple Pana": "ట్రిపుల్ పానా",
  "Triple Pana Bulk": "ట్రిపుల్ పానా బల్క్",
  "Half Sangam": "హాఫ్ సంగం",
  "Full Sangam": "ఫుల్ సంగం",
  "Jodi": "జోడి",
  "Single Panna": "సింగిల్ పానా",
  "Double Panna": "డబుల్ పానా",
  "Triple Panna": "ట్రిపుల్ పానా",
  "Tripple Panna": "ట్రిపుల్ పానా",

  // Playing
  "Enter points": "పాయింట్లు నమోదు చేయండి",
  "Enter {label}": "{label} నమోదు చేయండి",
  "Add Bid": "బిడ్ జోడించండి",
  "Submit Bid": "బిడ్ సమర్పించండి",
  "Pana": "పానా",
  "Digits": "అంకెలు",
  "Open Pana": "ఓపెన్ పానా",
  "Close Pana": "క్లోజ్ పానా",
  "Open Digit": "ఓపెన్ డిజిట్",
  "Close Digit": "క్లోజ్ డిజిట్",
  "No bids added yet": "ఇంకా బిడ్‌లు జోడించలేదు",
  "Remove bid {number}": "బిడ్ {number} తీసివేయండి",
  "Bid status": "బిడ్ స్థితి",
  "Note: Bid once played will not be cancelled": "గమనిక: ఒకసారి వేసిన బిడ్ రద్దు చేయబడదు",
  "HOLD": "హోల్డ్",
  "LOADING...": "లోడ్ అవుతోంది...",
  "Failed !!": "విఫలమైంది !!",

  // Bids / history
  "Transaction ID": "లావాదేవీ ID",
  "Placed": "వేయబడింది",
  "No bid history found.": "బిడ్ చరిత్ర కనుగొనబడలేదు.",
  "Balance": "బ్యాలెన్స్",
  "No transactions yet": "ఇంకా లావాదేవీలు లేవు",
  "Deposit": "డిపాజిట్",
  "No history found.": "చరిత్ర కనుగొనబడలేదు.",
  "In Process": "ప్రాసెస్‌లో ఉంది",
  "Declined": "తిరస్కరించబడింది",
  "User Withdrawal / deposit History": "విత్‌డ్రా / డిపాజిట్ చరిత్ర",

  // Charts
  "Bottom": "కిందకు",
  "Back to top": "పైకి వెళ్ళండి",
  "Mon": "సోమ",
  "Tue": "మంగళ",
  "Wed": "బుధ",
  "Thu": "గురు",
  "Fri": "శుక్ర",
  "Sat": "శని",
  "Sun": "ఆది",

  // Rates / how to play
  "Main game win ratio for all bids": "అన్ని బిడ్‌లకు ప్రధాన గేమ్ గెలుపు నిష్పత్తి",
  "{min} KA {max}": "{min} కి {max}",
  "How To Play": "ఎలా ఆడాలి",
  "Download our application from Google Play Store or from our official website.": "మా యాప్‌ను Google Play Store లేదా మా అధికారిక వెబ్‌సైట్ నుండి డౌన్‌లోడ్ చేసుకోండి.",
  "Register with your Mobile Number, Email ID, and User Name on our platform.": "మీ మొబైల్ నంబర్, ఇమెయిల్ ID మరియు యూజర్ నేమ్‌తో మా ప్లాట్‌ఫామ్‌లో నమోదు చేసుకోండి.",
  "Login to the application using your Mobile Number and MPIN.": "మీ మొబైల్ నంబర్ మరియు MPIN తో యాప్‌లో లాగిన్ అవ్వండి.",
  "Select the Game type, choose your favourite number, and start to play the game.": "గేమ్ రకాన్ని ఎంచుకుని, మీకు ఇష్టమైన నంబర్‌ను ఎంచుకుని ఆడటం ప్రారంభించండి.",
  "Get a chance to win up to 10 Lac Points.": "10 లక్షల పాయింట్ల వరకు గెలిచే అవకాశం పొందండి.",

  // Wallet
  "Add Fund": "ఫండ్ జోడించండి",
  "Instant deposit via UPI / QR Code": "UPI / QR కోడ్ ద్వారా తక్షణ డిపాజిట్",
  "Manual Deposit": "మాన్యువల్ డిపాజిట్",
  "Upload your payment screenshot": "మీ చెల్లింపు స్క్రీన్‌షాట్‌ను అప్‌లోడ్ చేయండి",
  "Withdraw Fund": "ఫండ్ విత్‌డ్రా",
  "Fast and secure withdrawal to bank": "బ్యాంకుకు వేగవంతమైన, సురక్షితమైన విత్‌డ్రా",
  "Deposit & Withdraw History": "డిపాజిట్ & విత్‌డ్రా చరిత్ర",
  "Check your past transactions statement": "మీ గత లావాదేవీల స్టేట్‌మెంట్ చూడండి",
  "Add Bank Details": "బ్యాంక్ వివరాలు జోడించండి",
  "Update bank account for instant payouts": "తక్షణ చెల్లింపుల కోసం బ్యాంక్ ఖాతాను అప్‌డేట్ చేయండి",
  "Total Wallet Balance": "మొత్తం వాలెట్ బ్యాలెన్స్",
  "Pay": "చెల్లించండి",
  "Minimum deposit limit is {amount}.": "కనీస డిపాజిట్ పరిమితి {amount}.",
  "Enter withdraw points": "విత్‌డ్రా పాయింట్లు నమోదు చేయండి",
  "Amount is sent to your saved bank account.": "మొత్తం మీరు సేవ్ చేసిన బ్యాంక్ ఖాతాకు పంపబడుతుంది.",
  "Update bank details": "బ్యాంక్ వివరాలు అప్‌డేట్ చేయండి",
  "Pay to the UPI ID below, then enter the UTR number and upload the payment screenshot.": "కింది UPI ID కి చెల్లించి, UTR నంబర్ నమోదు చేసి, చెల్లింపు స్క్రీన్‌షాట్‌ను అప్‌లోడ్ చేయండి.",
  "Enter amount": "మొత్తం నమోదు చేయండి",
  "Pay to UPI ID": "ఈ UPI ID కి చెల్లించండి",
  "UTR Number": "UTR నంబర్",
  "Enter 12-digit UTR number": "12 అంకెల UTR నంబర్ నమోదు చేయండి",
  "Payment Screenshot": "చెల్లింపు స్క్రీన్‌షాట్",
  "Tap to upload screenshot": "స్క్రీన్‌షాట్ అప్‌లోడ్ చేయడానికి నొక్కండి",
  "Tap to change": "మార్చడానికి నొక్కండి",
  "PNG or JPG": "PNG లేదా JPG",
  "Bank Details": "బ్యాంక్ వివరాలు",
  "IFSC Code": "IFSC కోడ్",
  "Account number": "ఖాతా నంబర్",
  "Bank name": "బ్యాంక్ పేరు",
  "Account holder name": "ఖాతాదారుని పేరు",
  "Google Pay number": "Google Pay నంబర్",
  "PhonePe number": "PhonePe నంబర్",
  "Paytm number": "Paytm నంబర్",

  // Profile
  "Edit profile": "ప్రొఫైల్ సవరించండి",
  "Joined since": "చేరిన తేదీ",
  "Phone": "ఫోన్",
  "Wallet Balance": "వాలెట్ బ్యాలెన్స్",
  "Update User Information": "యూజర్ సమాచారాన్ని అప్‌డేట్ చేయండి",
  "Name": "పేరు",
  "Email": "ఇమెయిల్",
  "PhonePe": "PhonePe",
  "Google Pay": "Google Pay",
  "Paytm": "Paytm",
  "Name is required.": "పేరు అవసరం.",
  "Email is required.": "ఇమెయిల్ అవసరం.",
  "Email is invalid.": "ఇమెయిల్ సరైనది కాదు.",
  "PhonePe number must be 10 digits.": "PhonePe నంబర్ 10 అంకెలు ఉండాలి.",
  "Paytm number must be 10 digits.": "Paytm నంబర్ 10 అంకెలు ఉండాలి.",
  "Google Pay number must be 10 digits.": "Google Pay నంబర్ 10 అంకెలు ఉండాలి.",

  // Pop-up messages
  "Enter User name !!": "యూజర్ నేమ్ నమోదు చేయండి !!",
  "Enter Valid mobile number !!": "సరైన మొబైల్ నంబర్ నమోదు చేయండి !!",
  "Enter Valid email address !!": "సరైన ఇమెయిల్ చిరునామా నమోదు చేయండి !!",
  "Enter your 4-digit MPIN !!": "మీ 4 అంకెల MPIN నమోదు చేయండి !!",
  "Only 4 digit allow !!": "4 అంకెలు మాత్రమే అనుమతించబడతాయి !!",
  "Mpin does not match with confirm Mpin.": "MPIN మరియు నిర్ధారణ MPIN సరిపోలలేదు.",
  "This number is already registered. Please login.": "ఈ నంబర్ ఇప్పటికే నమోదైంది. దయచేసి లాగిన్ అవ్వండి.",
  "This number is not registered. Please create your account.": "ఈ నంబర్ నమోదు కాలేదు. దయచేసి మీ ఖాతాను సృష్టించండి.",
  "Unable to sign in. Please try again.": "లాగిన్ కాలేకపోయింది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
  "Unable to continue. Please try again.": "కొనసాగించలేకపోయాం. దయచేసి మళ్ళీ ప్రయత్నించండి.",
  "Unable to create account. Please try again.": "ఖాతా సృష్టించలేకపోయాం. దయచేసి మళ్ళీ ప్రయత్నించండి.",
  "Api Error": "సర్వర్ లోపం",
  "Something went wrong. Please try again.": "ఏదో తప్పు జరిగింది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
  "This Market Betting Is Closed For Today.": "ఈ మార్కెట్‌లో ఈరోజుకు బెట్టింగ్ మూసివేయబడింది.",
  "Please Enter minimum 10 Points.": "దయచేసి కనీసం 10 పాయింట్లు నమోదు చేయండి.",
  "Please Enter Points for Betting.": "దయచేసి బెట్టింగ్ కోసం పాయింట్లు నమోదు చేయండి.",
  "Please Select Bids for Betting.": "దయచేసి బెట్టింగ్ కోసం బిడ్‌లను ఎంచుకోండి.",
  "Please enter a valid Number.": "దయచేసి సరైన నంబర్ నమోదు చేయండి.",
  "Please Enter Amount first.": "దయచేసి ముందుగా మొత్తం నమోదు చేయండి.",
  "Please Enter UTR first.": "దయచేసి ముందుగా UTR నమోదు చేయండి.",
  "Please select a valid image file.": "దయచేసి సరైన ఇమేజ్ ఫైల్‌ను ఎంచుకోండి.",
  "UPI copied to clipboard!": "UPI క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది!",
  "Profile Updated Successfully.": "ప్రొఫైల్ విజయవంతంగా అప్‌డేట్ చేయబడింది.",
};

export default dict;
